import { Controller } from "@hotwired/stimulus"
import Chartkick from "chartkick"

export default class extends Controller {
  static values = { type: String, data: String, options: String }

  connect() {
    new Chartkick[this.typeValue](this.element, JSON.parse(this.dataValue), JSON.parse(this.optionsValue))
  }

  disconnect() {
    const chart = Chartkick.charts[this.element.id]
    if (chart) {
      chart.destroy()
      delete Chartkick.charts[this.element.id]
    }
  }
}
